import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, Workflow } from "lucide-react";

export const AdvancedModeNotice = ({ open, onOpenChange, onContinue }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="advanced-mode-notice"
      className="max-w-md overflow-hidden border-zinc-700 bg-[#101116] text-zinc-100"
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-rose-500/15 to-transparent" />
      <DialogHeader className="relative">
        <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-xl brand-gradient shadow-lg shadow-rose-500/25">
          <Workflow className="h-5 w-5 text-white" />
        </div>
        <DialogTitle>Save Material Mix for last</DialogTitle>
        <DialogDescription className="text-zinc-400 leading-relaxed">
          Build your height bands in Elevation and finish any hand painting in Manual Paint first. Material Mix is the finishing step for mixing materials and patterns.
        </DialogDescription>
      </DialogHeader>
      <div className="relative mt-2 grid grid-cols-2 gap-2">
        <Button
          data-testid="advanced-mode-stay"
          variant="outline"
          onClick={() => onOpenChange(false)}
          className="border-zinc-700 bg-zinc-900/60 text-zinc-200 hover:bg-zinc-800"
        >
          Stay here
        </Button>
        <Button
          data-testid="advanced-mode-continue"
          onClick={onContinue}
          className="brand-gradient font-semibold text-white shadow-md shadow-rose-500/20"
        >
          <Sparkles className="h-4 w-4" />
          Continue
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
